import React from 'react';
import i18next from '../../i18n.js';
import { signatureStates } from '../../constants.js';
import { Svg } from '../Svg.js';

const Signature = (props) => {

    return (<div className='signature'>
        <div className='sign-user-name'>{props.signature.name}</div>
        <div className='sign-date'>{props.signature.date}</div>
        <div className={'sign-status' + (props.signature.state === signatureStates.signed ? " signed" : " not-signed")}>{props.signature.state === signatureStates.signed ? i18next.t("other.signed") : i18next.t("other.notSigned")}
            {props.signature.state === signatureStates.signed && <Svg className='sign-svg' src="/img/sign.svg" />}
            {props.signature.state !== signatureStates.signed && <Svg className='sign-svg' src="/img/broken-sign.svg" />}
        </div>
    </div>);
}
export default Signature;